<app-table
    tableKey="serviceDashboardIndividualPlan"
    [items]="$any(store.revisions())"
    [hideCheckboxes]="true"
    [columns]="columns"
    translatePrefix="individualPlan."
    [showSearch]="false"
    [showColumnVisiblity]="false"
    [showExport]="false"
    [showClearFilter]="false"
    [defaultSorters]="[{ column: 'deadlineDate', direction: 'ASC' }]"
>
    <ng-template pTemplate="deadlineDate" let-item="item">
        <div [class.text-danger]="item.lastDay">
            {{ item.deadlineDate | localDate: 'd.M.y' }}
        </div>
    </ng-template>
</app-table>
